import styled from 'styled-components';
import { ModalBackdropStyled, Box } from '@bechtel/gds';

export const listWidth = '392px';
export const desktopScreenListWidth = '300px';
export const smallScreenListWidth = '286px';
const drawerWidth = '288px';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  left: ${listWidth};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    left: ${desktopScreenListWidth};
  }
`;

export const DrawerOuterStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  background-color: ${({ theme }) => theme.colors.white};
  height: 100%;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  width: ${drawerWidth};
`;
